<template>
  <div>
    <b-modal
      id="confirmForceAddDay"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg modal-lg"
      centered
    >
      <section class="text-center">
        <b-row>
          <b-col cols="12" class="py-4">
            <h3 class="font-weight-bold title-text">
              ⚠️ {{ t('confirmForceActiveAccommodationTitle') }}
            </h3>
          </b-col>

          <b-col cols="12" class="py-3">
            <p class="message-text" style="white-space: pre-line;">
              {{ t('confirmForceActiveAccommodationBody') }}
              <br><br>
              <strong>{{ t('noteLabel') }}</strong> {{ t('confirmForceAddDayWarning') }}
            </p>
          </b-col>

          <b-col cols="12" class="py-4">
            <b-btn
              pill
              variant="danger"
              class="action-button mb-3"
              @click="forceAddDay"
            >{{ t('confirmForceAddDayConfirm') }}</b-btn>

            <b-btn
              pill
              variant="secondary"
              class="action-button"
              @click="closePopup"
            >{{ t('cancel') }}</b-btn>
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: ["value"],
  data() {
    return {
      storedDayIndex: null
    }
  },
  computed: {
    ...mapGetters(["inerModalParameters"]),
    isVisible: {
      set(val) {
        if (val === true) {
          // Always update storedDayIndex when modal opens
          if (this.inerModalParameters?.dayIndex !== undefined) {
            this.storedDayIndex = this.inerModalParameters.dayIndex;
          }
        } else if (val === false) {
          // Clear stored values when modal closes
          this.storedDayIndex = null;
        }
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    dayIndex() {
      // Use stored value if available, otherwise fall back to inerModalParameters
      return this.storedDayIndex !== null ? this.storedDayIndex : this.inerModalParameters?.dayIndex;
    }
  },
  methods: {
    ...mapActions([
      "showModal",
      "fetchRide",
      "fetchRideHeaderInformation",
    ]),
    async forceAddDay() {
      // Get the dayIndex value
      const dayIndexValue = this.storedDayIndex !== null ? this.storedDayIndex : this.inerModalParameters?.dayIndex;
      
      // Safety check - ensure we have the dayIndex
      if (dayIndexValue === undefined || dayIndexValue === null) {
        this.showModal("");
        return;
      }
      
      this.showModal("loadingIcon");
      
      // Call the store action with force=true
      const success = await this.$store.dispatch('addNewDayToRide', {
        dayIndex: dayIndexValue,
        force: true
      });
      
      if (success) {
        this.closePopup();
      }
    },
    closePopup() {
      this.showModal("");
    },
  },
  watch: {
    value(newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          const params = this.$store.getters.inerModalParameters;
          if (params && params.dayIndex !== undefined) {
            this.storedDayIndex = params.dayIndex;
          } else {
            // Fallback to reading from computed property
            const computedParams = this.inerModalParameters;
            if (computedParams && computedParams.dayIndex !== undefined) {
              this.storedDayIndex = computedParams.dayIndex;
            }
          }
        });
      }
    }
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}

.title-text {
  font-size: 24px;
  color: #D32F2F;
  margin-bottom: 20px;
}

.message-text {
  font-size: 18px;
  color: #2E2E3A;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 85%;
}

.action-button {
  font-size: 18px;
  padding: 15px 30px;
  width: 80%;
  max-width: 500px;
  display: block;
  margin: 0 auto;
}

.action-button:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.modal-lg {
  max-width: 600px;
}
</style>

